module.exports = __webpack_public_path__ + "static/media/white-home (1).50ca16f7.png";